import React, { Component } from 'react';
import moment from 'moment';
import ModalAlteracoes from '../Modal-Alteracoes/Modal-Alteracoes';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import axios from 'axios';
import { Configurations } from '../../Utils/Configurations';

class HeaderPhrase extends Component {
    constructor(props) {
        super(props);

        this.voltar = this.voltar.bind(this);
        this.toggleModalAlteracoes = this.toggleModalAlteracoes.bind(this);
        this.toggleModalImg = this.toggleModalImg.bind(this);
        //this.salvarImagem = this.salvarImagem.bind(this);
        this.onSelectFileImage = this.onSelectFileImage.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
        this.state = {
            modalAlteracoes: false,
            modalImg: false,
            imagem: null,
            tipoImg: 1,
            loadingImg: false,
            msgUpload: '',
            successUpload: false
        };
    }

    voltar() {
        if (this.props.temAlteracao) this.toggleModalAlteracoes();
        else window.history.go(-1);
    }

    toggleModalAlteracoes() {
        this.setState({ modalAlteracoes: !this.state.modalAlteracoes })
    }
    toggleModalImg() {
        this.setState({ modalImg: !this.state.modalImg, msgUpload: '', successUpload: false, imagem: null, tipoImg: 1 })
    }
    onSelectFileImage(e) {
        this.setState({ imagem: e.target.files[0] })
    }
    onChangeInput(e) {
        this.setState({ tipoImg: parseInt(e.target.value), msgUpload: '' })
    }

    async salvarImg() {
        const config = new Configurations();
        var bodyFormData = new FormData();
        bodyFormData.append('imagem', this.state.imagem);
        bodyFormData.append('tipoImagem', this.state.tipoImg);
        bodyFormData.append('dtFrase', moment(this.props.date).format('YYYY-MM-DD'));

        this.setState({ loadingImg: true })

        await axios.post(config.apiBasePath + `/frase-do-dia/imagem/upload`, bodyFormData)

            .then(response => {
                this.setState({ loadingImg: false, msgUpload: 'Imagem salva com sucesso!', successUpload: true })

            }).catch(err => {
                console.log("ERROR:", err)
                this.setState({ loadingImg: false, msgUpload: 'Erro ao salvar imagem.', successUpload: false })
            });
    }

    render() {

        const itemHistorico = this.props.fraseDoDia.historico ? this.props.fraseDoDia.historico[this.props.fraseDoDia.historico.length - 1] : undefined;
        const {
            gerarImagem,
            flagNovaFrase,
            temAlteracao,
            isLoadingGerarImagem
        } = this.props;

        return (

            <div className="header-frase border-left border-bottom border-gray">
                <div className={`row no-gutters pt-${this.props.novaFrase ? '4' : '3'} pb-3 align-items-center`}>
                    <div className="col-3 px-3">
                        {!this.props.novaFrase ? (
                            [<p key={1} className="m-0">Status: <span className={`badge badge-${this.props.fraseDoDia.habilitado ? 'primary' : 'secondary badge-opacity'}`}>{(!this.props.fraseDoDia.habilitado ? "Ind" : "D") + `isponível`}</span>
                            </p>,
                            itemHistorico && <p key={2} className="m-0 d-none d-lg-block">Última modificação: {moment(itemHistorico.dtAlteracao).format("DD/MM/YYYY H:mm:ss")}
                            </p>]
                        ) : (
                            [<p key={1} className="m-0">Status: <span className={`badge badge-secondary badge-opacity`}>Nova frase</span>
                            </p>,
                            ]
                        )}
                    </div>
                    <div className="col-2 text-center px-3">
                        <button onClick={() => this.toggleModalImg()} disabled={flagNovaFrase || temAlteracao} className="btn btn-outline-info mx-1">Upload de imagem</button>
                    </div>
                    <div className="col-5 text-right pr-3">
                        <div className="row no-gutters">
                            <div className="col-3 text-center px-1">
                                {this.props.isLoadingAlteracoes ? (
                                    <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                ) : (
                                    <button disabled={!this.props.temAlteracao} onClick={this.props.salvarAlteracoes} className="btn btn-outline-success mx-1">{this.props.novaFrase ? 'criar frase' : 'salvar'}</button>
                                )}
                            </div>
                            <div className={`col-${this.props.novaFrase ? '4' : '4'} text-center px-1`}>
                                {isLoadingGerarImagem ? (
                                    <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                ) : (
                                    <button disabled={flagNovaFrase || temAlteracao} onClick={gerarImagem} className="btn btn-outline-primary mx-1">gerar imagem</button>
                                )}
                            </div>
                            {!this.props.novaFrase && (
                                <div className="col-3 text-center px-1">
                                    {this.props.isLoadingExcluir ? (
                                        <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                    ) : (
                                        <button onClick={this.props.excluirFrase} className="btn btn-outline-danger mx-1">excluir</button>
                                    )}
                                </div>
                            )}
                            <div className={`col-${this.props.novaFrase ? '4' : '2'} text-right`}>
                                <button onClick={this.voltar} className="btn btn-outline-secondary mx-1">voltar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalAlteracoes
                    isOpen={this.state.modalAlteracoes}
                    toggle={this.toggleModalAlteracoes}
                />

                <Modal size="lg" isOpen={this.state.modalImg} toggle={this.toggleModalImg}>
                    <ModalHeader toggle={this.toggleModalImg}>
                        Nova Imagem
                    </ModalHeader>
                    <ModalBody>
                        <div className='row'>
                            <div className='col-12 col-lg-4 form-check'>
                                <div className='ml-2 mb-1'>
                                    <input className="form-check-input" type="radio" name="tipoImage" id="capa" checked={this.state.tipoImg === 1} value={1} onChange={this.onChangeInput} />
                                    <label className="form-check-label" htmlFor="capa">Capa</label>
                                </div>

                                <div className='ml-2 mb-1'>
                                    <input className="form-check-input" type="radio" name="tipoImage" id="whatsapp" checked={this.state.tipoImg === 2} value={2} onChange={this.onChangeInput} />
                                    <label className="form-check-label" htmlFor="whatsapp">WhatsApp</label>
                                </div>

                                <div className='ml-2 mb-1'>
                                    <input className="form-check-input" type="radio" name="tipoImage" id="instagram" checked={this.state.tipoImg === 3} value={3} onChange={this.onChangeInput} />
                                    <label className="form-check-label" htmlFor="instagram">Instagram</label>
                                </div>
                            </div>
                            <div className='col-12 col-lg-8'>
                               <div className='d-flex align-items-center'>
                                 <form>
                                    <label>Upload de imagem para {this.state.tipoImg === 1 ? 'capa' : this.state.tipoImg === 2 ? 'WhatsApp' : 'Instagram'}:</label>
                                    <input name="imagem" type="file" accept='.jpg,.jpeg,.png' className="py-2" onChange={this.onSelectFileImage} />
                                </form>
                                {this.state.loadingImg ? (
                                    <div className="spinner-border spinner-border-sm mx-5 text-primary" role="status" />
                                ) : (
                                    <button className='btn btn-sm btn-outline-success' onClick={() => this.salvarImg()}>
                                        Salvar
                                    </button>
                                )}
                               </div>
                               {this.state.msgUpload && (
                                    <span className={`text-${this.state.successUpload ? 'success' : 'danger'}`}>
                                        <i className={`mr-1 fas fa-${this.state.successUpload ? 'check' : 'times'}`}></i>{this.state.msgUpload}
                                    </span>
                                )}
                            </div>
                        </div>

                    </ModalBody>

                    <ModalFooter>
                        <div className='justify-content-between d-flex w-100'>
                            <button className='btn btn-sm btn-outline-danger' onClick={() => this.toggleModalImg()} >
                                Cancelar
                            </button>
                        </div>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default HeaderPhrase;
